<template>
    <v-container fluid class="ma-0 pa-0 login-bg">
        <MFASVG :class="[this.$vuetify.breakpoint.smAndDown ? 'mfaSVG-mobile' : 'mfaSVG']"
                :rectColor="loginSVGColors.rectColor"
                :stopColor1="loginSVGColors.stopColor1"
                :stopColor2="loginSVGColors.stopColor2"
                :stopColor3="loginSVGColors.stopColor3"
                :circleColor1="loginSVGColors.circleColor1"
                :circleColor2="loginSVGColors.circleColor2">

        </MFASVG>
        <v-row>
            <v-toolbar flat>
                <v-hover v-slot="{hover}">
                    <v-btn @click="toggleLocale" class="text-none text-normal min-height-1" text absolute right plain :color="hover ? 'linkHover' : 'primary'">{{$t('login.locale')}}</v-btn>
                </v-hover>
            </v-toolbar>
        </v-row>
        <v-row>
            <v-col>
                <v-row align="center" justify="center" class="py-16">
                    <!--<v-col align-self="auto"></v-col>-->
                    <v-col align="center">
                        <v-card class="my-auto px-10 pt-8 rounded-xl"
                                max-width="615px"
                                flat>
                            <v-row :class="[ this.$vuetify.breakpoint.smAndDown ? 'my-6' : 'my-13' ]"
                                   align="center"
                                   justify="center">
                                <v-icon size="128"
                                        color="primary">
                                    mdi-lock
                                </v-icon>
                            </v-row>
                            <v-card-title class="d-block text-center card-title">{{$t('login.mfaTitle')}}</v-card-title>
                            <v-card-subtitle class="text-center card-subtitle">{{this.mfaType == 0 ? $t('login.mfaSubTitle', { email: this.user.mfaEmail }) : $t('login.mfaSubTitleSms', { sms: this.user.mfaSms }) }}</v-card-subtitle>
                            <v-alert v-if="alert.message" class="mx-4 pa-3 d-inline-block" dense dark :type="alert.type">{{$t(alert.message)}}</v-alert>
                            <v-form ref="mfaForm" v-model="formValid" lazy-validation @submit.prevent="handleSubmit">
                                <v-card-text class="pb-0">
                                    <label for="mfa-code-input" class="sr-only">{{$t('login.mfaCode')}}</label>
                                    <v-row>
                                        <v-otp-input id="mfa-code-input"
                                                     length="7"
                                                     type="number"
                                                     class="mx-2"
                                                     :class="this.$vuetify.breakpoint.smAndDown ? 'v-otp-input-mobile' : ''"
                                                     :rules="mfaCodeRules"
                                                     aria-label="Verification code"
                                                     aria-required="true"
                                                     @finish="onFinish">

                                        </v-otp-input>
                                    </v-row>
                                    <v-row v-if="!waitToResend && retryResendCount >= 1 && this.user.mfaSms"
                                           class="d-flex justify-space-between mt-3">
                                        <v-radio-group v-model="mfaType" 
                                                       class="ml-3"
                                                       dense>
                                            <v-radio :key="0"
                                                     class="mfaTypeLabel"
                                                     :label="$t('login.mfaTypeEmail', { email: this.user.mfaEmail })"
                                                     :value="0"></v-radio>
                                            <v-radio :key="1"
                                                     class="mfaTypeLabel"
                                                     :label="$t('login.mfaTypeSms', { sms: this.user.mfaSms })"
                                                     :value="1"></v-radio>
                                        </v-radio-group>
                                    </v-row>
                                    <v-row v-if="!waitToResend" class="d-flex justify-space-between mt-3">
                                        <v-hover v-slot="{hover}">
                                            <v-btn class="text-none text-small"
                                                   text plain
                                                   :color="hover ? 'linkHover' : 'primary'"
                                                   @click="resendCode">
                                                {{$t('login.mfaResendCode')}}
                                            </v-btn>
                                        </v-hover>
                                    </v-row>
                                    <v-row v-else class="mt-4">
                                        <span class="px-4 text-small">{{$t('login.timeLeftBeforeResend',{ second: this.timeLeftBeforeResend })}}</span>
                                    </v-row>
                                        <v-row class="my-3">
                                            <v-hover v-slot="{hover}">
                                                <v-btn class="text-none text-small" text plain :color="hover ? 'linkHover' : 'primary'" to="/login">{{$t('login.mfaReturnToLogin')}}</v-btn>
                                            </v-hover>
                                        </v-row>
                                </v-card-text>
                                <v-card-actions class="mx-2">
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none mb-8 text-normal min-height-1" :disabled="submitted" depressed block :dark="!submitted" :color="hover ? 'buttonHover' : 'primary'" type="submit">
                                            {{$t('login.validate')}} &nbsp;
                                            <v-progress-circular v-if="submitted"
                                                                 indeterminate 
                                                                 color="primary"/>
                                        </v-btn>
                                    </v-hover>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import { loginService } from "../../services";
    import MFASVG from '../../components/2FA_SVG.vue';

    export default {
        components: { MFASVG },
        data() {
            return {
                mfaCode: '',
                formValid: true,
                submitted: false,
                logo: "",
                mfaCodeRules: [
                    v => !!v || '',
                    v => (v && v.length == 7) || '',
                ],
                waitToResend: true,
                resendDelays: [30,40,60,90,120],
                retryResendCount: 0,
                timeLeftBeforeResend: 30,
                mfaType: 0,
            };
        },
        computed: {
            ...mapState("account", ["status", "user"]),
            ...mapState({ alert: state => state.alert }),

            loginSVGColors() {
                return this.$vuetify.theme.themes.light.loginSVG;
            },
        },
        mounted() {
            this.mfaType = this.user.mfaType;
            this.setResendInterval();
        },
        watch: {
            'alert.message'() {
                this.submitted = false;
            },
            
        },
        methods: {
            ...mapActions("account", ["validateMFACode"]),
            ...mapActions({ clearAlert: 'alert/clear' }),
            ...mapActions({ errorAlert: 'alert/error' }),
            ...mapActions({ successAlert: 'alert/success' }),

            toggleLocale() {
                this.$emit("toggleLocale");
            },
            resendCode() {
                this.clearAlert();
                loginService.resendCode(this.user.mfaAuditRoot, this.user.userid, this.mfaType)
                    .then(() => {
                        this.successAlert('login.mfacode-resend');
                        setTimeout(() => {
                            this.clearAlert();
                        }, 7000);
                        this.timeLeftBeforeResend = this.resendDelays[this.retryResendCount];
                        this.retryResendCount = this.retryResendCount == 4 ? this.retryResendCount : this.retryResendCount + 1;
                        this.setResendInterval();
                    })
                    .catch(error => {
                        this.errorAlert(error.message);
                    });
            },
            setResendInterval() {
                this.waitToResend = true;

                let interval = setInterval(() => {
                    this.timeLeftBeforeResend--;
                    if (this.timeLeftBeforeResend == 0) {
                        this.waitToResend = false;
                        clearInterval(interval);
                    }
                }, 1000);

            },
            handleSubmit() {
                this.clearAlert();
                this.$refs.mfaForm.validate();
                const data = {
                    audit: this.user.mfaAuditRoot,
                    userid: this.user.userid,
                     mfacode: this.mfaCode
                }
                this.$nextTick(() => {
                    if (this.formValid) {
                        this.submitted = true;
                        this.validateMFACode(data)
                            .catch((error) => {
                                this.submitted = false;
                                this.errorAlert(error);
                            });
                    }
                })
            },
            onFinish(code) {
                this.mfaCode = code;
            }
        }
    }
</script>

<style scoped>
    .login-card-radius {
        border-radius: 20px;
    }

    .mfaSVG {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 50%;
    }

    .mfaSVG-mobile {
        position: absolute;
        top: 48px;
        width: 100%;
        height: 50%;
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }

    .v-otp-input >>> input{
        font-size: 40px !important;
        min-height: 87px !important;
        border-radius: 10px;
        text-align: center !important;
    }

    .v-otp-input-mobile >>> input {
        font-size: 20px !important;
        min-height: 48px !important;
        border-radius: 5px;
        text-align: center !important;
    }
    .mfaTypeLabel >>> label {
        font-size: 14px !important;
    }
</style>